import { memo } from 'react';

import AlertFilledIconSVG from '@/assets/alert-filled-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAlertFilledIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={AlertFilledIconSVG} {...props} />
);

export const AlertFilledIcon = memo(IAlertFilledIcon) as typeof IAlertFilledIcon;
